import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { styled } from 'styled-components';
import { authAxios } from '../../api/customAxios';
import ApplyButton from '../../components/button/ApplyButton';
import CurryButton from '../../components/button/CurryButton';
import VolumeButton from '../../components/button/VolumeButton';
import ApplyFooter from '../../layout/footer/ApplyFooter';
import TopHeader from '../../layout/header/TopHeader';
import { correctAnswersState, tokenState } from '../../recoil/atom';
import theme from '../styles/theme';

function LevelTest4() {
	const [activeButton, setActiveButton] = useState('');
	const [hobbyButton, setHobbyButton] = useState('');
	const [isCorrect, setIsCorrect] = useState(false);
	const token = useRecoilValue(tokenState);
	const navigate = useNavigate();
	const [correctAnswers, setCorrectAnswers] =
		useRecoilState(correctAnswersState); // Recoil atom 상태 추가	// const [touchPosition, setTouchPosition] = useState({ x: 0, y: 0 });
	// const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });
	const [dragging, setDragging] = useState(false);
	const [dragPosition, setDragPosition] = useState<{ x: number; y: number }[]>(
		[]
	);
	const [touchLocations, setTouchLocations] = useState<
		{ x: number; y: number }[]
	>([]);

	const handleMouseDown: React.MouseEventHandler<HTMLDivElement> = (event) => {
		setDragging(true);
		handleMouseMove(event); // Call handleMouseMove directly to set initial position
	};

	const handleMouseUp: React.MouseEventHandler<HTMLDivElement> = () => {
		setDragging(false);
	};

	// const touchLocation = [];

	const handleMouseMove: React.MouseEventHandler<HTMLDivElement> = (event) => {
		if (!dragging) return;

		const dragX = event.clientX;
		const dragY = event.clientY;
		const screenWidth = window.innerWidth;
		const screenHeight = window.innerHeight;

		const normalizedX = (dragX / screenWidth) * 100;
		const normalizedY = (dragY / screenHeight) * 100;

		setTouchLocations((prevLocations) => [
			...prevLocations,
			{ x: normalizedX, y: normalizedY },
		]);
	};

	// const handleTouchMove: React.TouchEventHandler<HTMLDivElement> = (event) => {
	// 	const touch = event.touches[0];
	// 	const screenWidth = window.innerWidth;
	// 	const screenHeight = window.innerHeight;

	// 	const touchX = touch.clientX;
	// 	const touchY = touch.clientY;

	// 	const normalizedX = (touchX / screenWidth) * 100;
	// 	const normalizedY = (touchY / screenHeight) * 100;

	// 	// setTouchPosition({ x: normalizedX, y: normalizedY });
	// 	setTouchLocations((prevLocations) => [
	// 		...prevLocations,
	// 		{ x: normalizedX, y: normalizedY },
	// 	]);
	// };

	const handleClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
		const clickX = event.clientX;
		const clickY = event.clientY;
		const screenWidth = window.innerWidth;
		const screenHeight = window.innerHeight;

		const normalizedX = (clickX / screenWidth) * 100;
		const normalizedY = (clickY / screenHeight) * 100;

		// setClickPosition({ x: normalizedX, y: normalizedY });
		setTouchLocations((prevLocations) => [
			...prevLocations,
			{ x: normalizedX, y: normalizedY },
		]);
	};
	console.log('클릭', touchLocations);
	console.log('드래그', dragPosition);

	const handleButtonClick = (buttonName: string) => {
		setActiveButton(buttonName);
	};

	const hobbyButtonClick = (buttonName: string) => {
		setHobbyButton(buttonName);
	};

	useEffect(() => {
		if (activeButton === '30대' && hobbyButton === '노래하기') {
			setIsCorrect(true);
		} else {
			setIsCorrect(false);
		}
		console.log(correctAnswers);
	}, [activeButton, hobbyButton]);
	console.log(isCorrect);
	console.log(activeButton);
	console.log(hobbyButton);
	const fetchCode = async () => {
		if (isCorrect == true) {
			setCorrectAnswers(correctAnswers + 1);
		}
		try {
			const user = await authAxios(token).post(`/quiz/evaluation`, {
				quizId: 2,
				userAnswer: String({ activeButton, hobbyButton }),
				isCorrect: isCorrect,
			});
			const userClick = await authAxios(token).post(`/quiz/curriculum`, {
				quizId: 2,
				clickLocation: touchLocations,
			});

			console.log(userClick);
			console.log(user);
			console.log('정답', isCorrect);

			console.log(user);
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<Container
			onClick={handleClick}
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
			onMouseMove={handleMouseMove}
		>
			<Content>
				<TopHeader title='나에게 맞는 수업 찾기' page='/levelTest3' />
				<RangeBarWrap>
					<div>4/14</div>
					<RangeBar type='range' min={0} max={14} step={4} defaultValue={4} />
				</RangeBarWrap>
				<MentBox>
					31살 임영웅씨는
					<br /> 노래 부르는 것을 좋아해요.
					<br /> 아래에서 `조건에` 맞는것을 골라볼까요?
				</MentBox>
				<ButtonWrap>
					<AgeWrap>
						나이
						<AgeButtonWrap>
							<CurryButton
								active={activeButton === '20대'}
								onClick={() => {
									handleButtonClick('20대');
								}}
								children='20대'
							/>
							<CurryButton
								active={activeButton === '30대'}
								onClick={() => {
									handleButtonClick('30대');
								}}
								children='30대'
							/>
							<CurryButton
								active={activeButton === '40대'}
								onClick={() => {
									handleButtonClick('40대');
								}}
								children='40대'
							/>
							<CurryButton
								active={activeButton === '50대'}
								onClick={() => {
									handleButtonClick('50대');
								}}
								children='50대'
							/>
							<CurryButton
								active={activeButton === '60대'}
								onClick={() => {
									handleButtonClick('60대');
								}}
								children='60대'
							/>
							<CurryButton
								active={activeButton === '70대'}
								onClick={() => {
									handleButtonClick('70대');
								}}
								children='70대'
							/>
						</AgeButtonWrap>
					</AgeWrap>
					<HobbyWrap>
						취미
						<HobbyButtonWrap>
							<CurryButton
								active={hobbyButton === '노래하기'}
								onClick={() => {
									hobbyButtonClick('노래하기');
								}}
								children='노래하기'
							/>
							<CurryButton
								active={hobbyButton === '춤추기'}
								onClick={() => {
									hobbyButtonClick('춤추기');
								}}
								children='춤추기'
							/>
							<CurryButton
								active={hobbyButton === '그림그리기'}
								onClick={() => {
									hobbyButtonClick('그림그리기');
								}}
								children='그림그리기'
							/>
						</HobbyButtonWrap>
					</HobbyWrap>
				</ButtonWrap>
				<ApplyFooter>
					<VolumeButton />
					<ApplyButton
						disabled={false}
						onClick={() => {
							fetchCode();
							navigate('/levelTest5');
							console.log(fetchCode());
						}}
					>
						다음
					</ApplyButton>
				</ApplyFooter>
			</Content>
		</Container>
	);
}

const Container = styled.div`
	height: 100vh;
	margin: 0 auto;
	background-color: ${theme.white};
`;

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 85%;
	height: 100vh;
	margin: 0 auto;
`;

const RangeBarWrap = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-top: 24px;
`;
const RangeBar = styled.input`
	width: 100%;
	height: 8px;
	background:
		linear-gradient(to right, #ccc, #ccc) no-repeat,
		linear-gradient(to right, #fd698d, #fd698d) no-repeat;
	background-size:
		100% 100%,
		100% 100%;
	border-radius: 8px;
	outline: none;
	transition: background-size 450ms ease-in;
	-webkit-appearance: none;
	accent-color: #fd698d;
	margin-top: 19px;

	&:hover {
		cursor: pointer;
	}

	&:focus {
		background:
			linear-gradient(to right, #ccc, #ccc) no-repeat,
			linear-gradient(to right, #fd698d, #fd698d) no-repeat;
		background-size:
			100% 100%,
			100% 100%;
	}
`;

const MentBox = styled.div`
	font-size: 24px;
	width: 100%;
	height: 144px;
	display: flex;
	align-items: baseline;
	justify-content: baseline;
	margin-top: 34px;
	line-height: 150%; /* 36px */
`;

const ButtonWrap = styled.div`
	width: 90%;
`;
const AgeWrap = styled.div`
	margin-top: 28px;
`;
const AgeButtonWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-around;
`;

const HobbyWrap = styled.div`
	margin-top: 37px;
`;

const HobbyButtonWrap = styled.div`
	display: flex;
	justify-content: space-around;
`;

export default LevelTest4;
